export const MAX_WIDGET_NUM = 8;
export const MAX_WIDGET_CATEGORIES_NUM = 8;
export const TEXT_WIDGET_CHARACTER_LIMIT = 1024 + 1;
